'use strict'

import React from 'react';

import Layout from '../Layout.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';
import Field from '../components/Field3.jsx';
import Slides from '../components/Slides.jsx';
import FormattedContent from '../components/FormattedContent.jsx';
import {ReportMessage} from '../log/HighlightReport.jsx';
import {FormattedSlide} from '../components/Slides.jsx';
import getProjectBrief from  '../../app/model/getProjectBrief.js';

import sendCommand from '../../app/utils/sendCommand.js';

import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]).loadVariants([
    require('./labels/product/english#productPlan.js')
  ]);

class Paragraph extends React.Component {
  render() {
    return this.props.value!==undefined && this.props.value!==null && this.props.value.trim().length>0 ? (
      <p>
        <FormattedContent value={this.props.value}/>
      </p>
    ) : null;
  }
}

class Background extends React.Component {
  render() {
    return (
      <div>
        {this.props.presentationMode ? (
            <h3>{this.props.title}</h3>
        ) : null}
        <Paragraph value={this.props.initiated}/>
        <Paragraph value={this.props.timing}/>
        <Paragraph value={this.props.bigPicture}/>
      </div>
    );
  }
}

class Objectives extends React.Component {
  hasValue(field) {
    return field!==undefined && field!==null && field.trim().length>0;
  }

  hasObjective(objective) {
    return objective!==undefined && (this.hasValue(objective.description) || this.hasValue(objective.tolerance));
  }

  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).definition.objectives;
    let hasObjectives=this.props.benefits!==undefined || this.props.summary!==undefined
      && this.props.summary.length>0 && this.props.summary.filter(item=>this.hasObjective(item)).length>0;
    return hasObjectives ? (
      <div>
        <h3>{this.props.title}</h3>
        <Paragraph value={this.props.benefits}/>
        {this.props.summary!==undefined && this.props.summary!==null && this.props.summary.length>0 && this.props.summary.filter(item=>this.hasObjective(item)).length>0 ? (
          <table style={{fontSize:"inherit", borderCollapse:"collapse", border: "solid 1px lightgrey", width:"100%"}}>
            <thead>
              <tr style={{backgroundColor: "#e9e7e6"}}>
                <th style={{border: "solid lightgrey 1px", padding:5, width:1, whiteSpace:"nowrap", paddingRight:20}}>{labels.columns.name.title}</th>
                <th style={{border: "solid lightgrey 1px", padding:5}}>{labels.columns.description.title}</th>
                <th style={{border: "solid lightgrey 1px", padding:5}}>{labels.columns.tolerance.title}</th>
              </tr>
            </thead>
            <tbody>
              {this.props.summary.map(item=>
                this.hasObjective(item) ? (
                <tr key={item.id}>
                  <td style={{border: "solid lightgrey 1px", padding:5, verticalAlign:"top", fontWeight: "bold"}}>{labels.aspects[item.id]}</td>
                  <td style={{border: "solid lightgrey 1px", padding:5, verticalAlign:"top"}}><FormattedContent value={item.description}/></td>
                  <td style={{border: "solid lightgrey 1px", padding:5, verticalAlign:"top"}}><FormattedContent value={item.tolerance}/></td>
                </tr>
              ) : null)}
            </tbody>
          </table>
        ) : null}
        <div style={{paddingTop: 10}}>
          <Paragraph value={this.props.comments}/>
        </div>
      </div>
    ) : null;
  }
}

class Scope extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).definition.scope;
    let hasScope=this.props.scope.items!==undefined && this.props.scope.items.length>0
      || this.props.scope.exclusions!==undefined || this.props.outcomes!==undefined;
    return hasScope ? (
      <div>
        {!this.props.presentationMode ? <h3>{labels.title}</h3> : null}
        {this.props.scope.items!==undefined && this.props.scope.items!==null && this.props.scope.items.length>0 ? (
          <ul>
            {this.props.scope.items.map((item,index)=><li key={index}>{item.text}</li>)}
          </ul>
        ) : null}
        {this.props.scope.exclusions!==undefined && this.props.scope.exclusions!==null && this.props.scope.exclusions.trim().length>0 ? (
          <div>
            <h4>{labels.excluded.title}</h4>
            <FormattedContent value={this.props.scope.exclusions}/>
          </div>
        ) : null}
        {this.props.outcomes!==undefined && this.props.outcomes!==null ? (
          <div>
            <h4>{labels.outcomes.title}</h4>
            <FormattedContent value={this.props.outcomes}/>
          </div>
        ) : null}
      </div>
    ) : null;
  }
}

class Constraints extends React.Component {
  render() {
    return this.props.constraints !==undefined && this.props.constraints!==null && this.props.constraints.trim().length>0? (
      <div>
        <h3>{this.props.title}</h3>
        <FormattedContent value={this.props.constraints}/>
      </div>
    ) : null;
  }
}

class Assumptions extends React.Component {
  render() {
    return (this.props.assumptions!==undefined && this.props.assumptions!==null && this.props.assumptions.trim().length>0) ?
      <div>
        <h3>{this.props.title}</h3>
        <FormattedContent value={this.props.assumptions}/>
      </div>
    : null;
  }
}

class Stakeholders extends React.Component {
  render() {
    return this.props.stakeholders!==undefined && this.props.stakeholders!==null && this.props.stakeholders.trim().length>0 ? (
      <div>
        <h3>{this.props.title}</h3>
        <FormattedContent value={this.props.stakeholders}/>
      </div>
    ) : null;
  }
}

class Interfaces extends React.Component {
  render() {
    return (this.props.interfaces!==undefined && this.props.interfaces!==null && this.props.interfaces.trim().length>0) ? (
      <div>
        <h3>{this.props.title}</h3>
        <FormattedContent value={this.props.interfaces}/>
      </div>
    ) : null;
  }
}

class Definition extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).definition;
    return (
      <div>
        <h2>{labels.title}</h2>
        <Background {...this.props} {...this.props.background}/>
        <Objectives {...this.props} {...this.props.objective} title={labels.objectives.title}/>
        <Scope {...this.props}/>
        <Constraints {...this.props} title={labels.constraints.title}/>
        <Assumptions {...this.props} title={labels.assumptions.title}/>
        <Stakeholders {...this.props} title={labels.stakeholders.title}/>
        <Interfaces {...this.props} title={labels.interfaces.title}/>
      </div>
    );
  }
}


class ObjectiveTableRow extends React.Component {
  hasValue(field) {
    return field!==undefined && field!==null && field.trim().length>0;
  }

  hasObjective(objective) {
    return objective!==undefined && (this.hasValue(objective.description) || this.hasValue(objective.tolerance));
  }

  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).definition.objectives;
    let hasObjectives=this.props.objective.benefits!==undefined && this.props.objective.benefits!==null && this.props.objective.benefits.trim().length>0 ||
      (this.props.objective.summary!==undefined && this.props.objective.summary.filter(item=>this.hasObjective(item)).length>0)
      || this.props.objective.comments!==undefined && this.props.objective.comments!==null && this.props.objective.comments.trim().length>0;
    return hasObjectives ? (
      <TableRow
        label={labels.title}
        content={(
          <div>
            <Paragraph value={this.props.objective.benefits}/>
            {this.props.objective.summary!==undefined ? (
              <div style={{display:"table", fontSize:"inherit"}}>
                {this.props.objective.summary.map(item=>
                  this.hasObjective(item) ? (
                    <div key={item.id} style={{display:"table-row"}}>
                      <div style={{display: "table-cell"}}>
                        <div style={{paddingRight: 5, verticlaAlign:"top"}}>
                          <b>{labels.aspects[item.id]}</b>:
                        </div>
                      </div>
                      <div style={{display:"table-cell"}}>
                        <div style={{display: "flex", flexWrap:"wrap"}}>
                          {this.hasValue(item.description) ? (
                            <div style={{paddingRight: 5, paddingBottom:5}}><FormattedContent value={item.description}/></div>
                          ): null}
                          {this.hasValue(item.tolerance) ? (
                            <div>{labels.columns.tolerance.title}: <FormattedContent value={item.tolerance}/></div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            ) : null }
            {this.hasValue(this.props.objective.comments) ? (
              <div style={{paddingTop: 10, fontStyle:"italic"}}>
                <FormattedContent value={this.props.objective.comments}/>
              </div>
            ) : null}
          </div>
        )}
      />
  ) : null;
  }
}

export class TableRow extends React.Component {
  render() {
    let cellStyle={ border: "solid 1px lightgrey", padding: 5};
    return this.props.content!==undefined && this.props.content!==null && (this.props.content.trim!==undefined && this.props.content.trim().length>0 || this.props.content.trim===undefined)? (
      <tr>
        <td style={Object.assign({},cellStyle,{verticalAlign:"top", fontWeight:"bold"})}>{this.props.label}</td>
        <td style={cellStyle}><FormattedContent value={this.props.content}/></td>
      </tr>
    ) : null;
  }
}

class DefinitionTable extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).definition;
    return (
      <div>
        <h2>{labels.title}</h2>
        <table className="briefTable" style={{fontSize:"inherit", borderCollapse: "collapse"}} cellPadding="0" cellSpacing="0">
          <tbody>
            <TableRow
              label={labels.background.title}
              content={<Background {...this.props} {...this.props.background}/>}
            />
            <ObjectiveTableRow {...this.props}/>
            <TableRow
              label={labels.scope.title}
              content={this.props.scope.items!==undefined && this.props.scope.items!==null && this.props.scope.items.length>0 ? (
                <ul style={{margin: 0, paddingLeft: 20}}>
                  {this.props.scope.items.map((item,index)=><li key={index}>{item.text}</li>)}
                </ul>
              ) : null}
            />
            <TableRow
              label={labels.scope.excluded.title}
              content={this.props.scope.exclusions}
            />
            <TableRow
              label={labels.scope.outcomes.title}
              content={this.props.outcomes}
            />
            <TableRow
              label={labels.constraints.title}
              content={this.props.constraints}
            />
            <TableRow
              label={labels.assumptions.title}
              content={this.props.assumptions}
            />
            <TableRow
              label={labels.interfaces.title}
              content={this.props.interfaces}
            />
            <TableRow
              label={labels.stakeholders.title}
              content={this.props.stakeholders}
            />
          </tbody>
        </table>
      </div>
    );
  }
}

class BenefitsTable extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).businessCase;
    let businessCase=this.props;
    return businessCase.benefits!==undefined && businessCase.benefits!==null && businessCase.benefits.length>0? (
      <table style={{fontSize:"inherit", borderCollapse:"collapse", border: "solid 1px lightgrey", width:"100%"}}>
        <thead>
          <tr style={{backgroundColor: "#e9e7e6"}}>
            <th>{labels.benefits.columns.title.title}</th>
            <th>{labels.benefits.columns.baseline.title}</th>
            <th>{labels.benefits.columns.goal.title}</th>
            <th>{labels.benefits.columns.accountable.title}</th>
          </tr>
        </thead>
        <tbody>
          {businessCase.benefits.map(item=>(
            <tr key={item.id}>
              <td style={{border: "solid lightgrey 1px", padding:5}}>{item.title}</td>
              <td style={{border: "solid lightgrey 1px", padding:5}}>{item.baseline}</td>
              <td style={{border: "solid lightgrey 1px", padding:5}}>{item.goal}</td>
              <td style={{border: "solid lightgrey 1px", padding:5}}>{item.accountable}</td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : null;
  }
}

class BusinessCase extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).businessCase;
    let businessCase=this.props;
    var hasBusinessCase=false;
    let reasonAndAlternativesFileds=["reasons","doNothing","doMinimal","doSomething"];
    let returnOnInvestmentFields=["projectPlanSummary","investmentAppraisal","risks"];
    reasonAndAlternativesFileds.concat(returnOnInvestmentFields).concat("benefits").forEach(key=>{
      hasBusinessCase=hasBusinessCase ||
        this.props[key]!==undefined &&
        (
          !Array.isArray(this.props[key])
          || Array.isArray(this.props[key]) && this.props[key].length>0
        );
    });
    return hasBusinessCase ? (
      <div>
        <h2>{labels.title}</h2>
        <FormattedContent value={businessCase.executiveSummary}/>
        {reasonAndAlternativesFileds.map(key=>
          <Section key={key} name={key} header={labels[key]} value={businessCase[key]}/>
        )}
        {businessCase.benefits!==undefined && businessCase.benefits!==undefined!==null && businessCase.benefits.length>0 ? (
          <div>
            <h3>{labels.benefits.title}</h3>
            <BenefitsTable {...this.props}/>
          </div>
        ) : null}
        {returnOnInvestmentFields.map(key=>
          <Section key={key} name={key} header={labels[key]} value={businessCase[key]}/>
        )}
      </div>
    ) : null;
  }
}

class BusinessCaseWithoutBenefitsTable extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).businessCase;
    let businessCase=this.props;
    let fields=["executiveSummary","reasons","doNothing","doMinimal","doSomething","projectPlanSummary","investmentAppraisal","risks"];
    var hasBusinessCase=false;
    fields.concat("benefits").forEach(key=>{
      hasBusinessCase=hasBusinessCase ||
        this.props[key]!==undefined &&
        (
          !Array.isArray(this.props[key])
          || Array.isArray(this.props[key]) && this.props[key].length>0
        );
    });
    return hasBusinessCase ? (
      <div>
        <h2>{labels.title}</h2>
        <table className="briefTable" style={{fontSize:"inherit", borderCollapse: "collapse"}} cellPadding="0" cellSpacing="0">
          <tbody>
            {fields.map(key=>
              <TableRow key={key} label={labels[key]} content={businessCase[key]}/>
            )}
          </tbody>
        </table>
      </div>
    ) : null;
  }
}

class DeliverablesHeading extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).projectProductDescription;
    let cellStyle={border: "solid lightgrey 1px", padding:5};
    return (
      <thead>
        <tr style={{backgroundColor: "#e9e7e6"}}>
          <th style={cellStyle}>{labels.columns.output.title}</th>
          <th style={cellStyle}>{labels.columns.qualityExpectation.title}</th>
          <th style={cellStyle}>{labels.columns.acceptanceCriteria.title}</th>
          <th style={cellStyle}>{labels.columns.acceptanceMethod.title}</th>
        </tr>
      </thead>
    );
  }
}

class ScopeDeliveriesTableGroup extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).projectProductDescription;
    let outputs=this.props.outputs;
    let cellStyle={border: "solid lightgrey 1px", padding:5};
    return outputs!==undefined && outputs!==null && outputs.length>0 ? (
      <tbody>
        {outputs.map(entry=>(
          <tr key={entry.id}>
            <td style={cellStyle}><FormattedContent value={entry.output}/></td>
            <td style={cellStyle}><FormattedContent value={entry.qualityExpectation}/></td>
            <td style={cellStyle}><FormattedContent value={entry.acceptanceCriteria}/></td>
            <td style={cellStyle}><FormattedContent value={entry.acceptanceMethod}/></td>
          </tr>
        ))}
      </tbody>
    ) : null;
  }
}

class ScopeDeliveriesText extends React.Component {
  hasValue(value) {
    return value!==undefined && value!==null && value.trim().length>0;
  }

  render() {
    let labels=translations.getTranslation(this.props).projectProductDescription;
    let outputs=this.props.outputs;
    return (
      <div>
        {outputs.map((entry,index)=>(
          <div key={entry.id} style={{marginBottom:(index+1)<outputs.length ? 15: 0}}>
            <table>
              <tbody>
                <tr>
                  <td style={{width:20}}></td>
                  <td><FormattedContent value={entry.output}/></td>
                </tr>
              </tbody>
            </table>
            <div>
              <table style={{fontSize:"inherit"}}>
                <tbody>
                  {this.hasValue(entry.qualityExpectation) ? (
                    <tr>
                      <td style={{width:40, paddingTop:5}}></td>
                      <td style={{color:"grey", paddingTop:5, verticalAlign:"top", whiteSpace:"nowrap"}}>{labels.columns.qualityExpectation.title}</td>
                      <td style={{paddingLeft: 5, paddingTop:5}}><FormattedContent value={entry.qualityExpectation}/></td>
                    </tr>
                  ) : null }
                  {this.hasValue(entry.acceptanceCriteria) ? (
                    <tr>
                      <td style={{width:40, paddingTop:5}}></td>
                      <td style={{color:"grey", paddingTop:5, verticalAlign:"top", whiteSpace:"nowrap"}}>{labels.columns.acceptanceCriteria.title}</td>
                      <td style={{paddingLeft: 5, paddingTop:5}}><FormattedContent value={entry.acceptanceCriteria} /></td>
                    </tr>
                  ) : null }
                  {this.hasValue(entry.acceptanceMethod) ? (
                    <tr>
                      <td style={{width:40, paddingTop:5}}></td>
                      <td style={{color:"grey", paddingTop:5,verticalAlign:"top", whiteSpace:"nowrap"}}>{labels.columns.acceptanceMethod.title}</td>
                      <td style={{paddingLeft: 5, paddingTop:5}}><FormattedContent value={entry.acceptanceMethod} /></td>
                    </tr>
                  ) : null }
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

class ProjectProductDescription extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).projectProductDescription;
    let outputs=this.props.items!==undefined && this.props.items!==null ? this.props.items.filter(item=>item.items!==undefined && item.items.length>0) : [];
    return this.props.items!==undefined && this.props.items!==null && this.props.items.length>0 && outputs.length>0 ? (
      <div>
        <h2>{labels.title}</h2>
        {this.props.items.map((item,index)=>(
          <div key={index}>
            <h3>{item.text}</h3>
            {item.items!==undefined && item.items.length>0 ? (
                <ScopeDeliveriesText {...this.props} outputs={item.items}/>
            ) : (
              <div style={{paddingLeft:20}}>
                <i>{labels.noOutputs}</i>
              </div>
            )}
          </div>
      ))}
    </div>
    ) : null;
  }
}

class ProjectProductDescriptionTable extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).projectProductDescription;
    let outputs=this.props.items!==undefined && this.props.items!==null ? this.props.items.filter(item=>item.items!==undefined && item.items.length>0) : [];
    return this.props.items!==undefined && this.props.items!==null && this.props.items.length>0 && outputs.length>0 ? (
      <div>
        <h2>{labels.title}</h2>
        {this.props.items.map((item,index)=>(
          <div key={index}>
            <h3>{item.text}</h3>
            {item.items!==undefined? (
              <table style={{fontSize:"inherit", borderCollapse:"collapse", border: "solid 1px lightgrey", width:"100%"}}>
                <DeliverablesHeading {...this.props}/>
                <ScopeDeliveriesTableGroup key={index} {...this.props} outputs={item.items}/>
              </table>)
              :labels.noOutputs}
          </div>))
        }
      </div>
    ) : null;
  }
}

class Section extends React.Component {
  render() {
    return this.props.value!==undefined && this.props.value!==null && this.props.value.trim().length>0? (
      <div>
        <h3>{this.props.header!==undefined ? this.props.header : ".("+this.props.name+")"}</h3>
        <FormattedContent value={this.props.value}/>
      </div>
    ) : null;
  }
}

class Approach extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).approach;
    let approach=this.props.approach;
    let fields=["methods","resources","technology","rollOut","other"];
    var hasApproach=false;
    if (approach!==undefined && approach!==null) {
      fields.forEach(key=>{
        hasApproach=hasApproach || approach[key]!==undefined && approach[key]!==null
      })
    }
    return hasApproach ? (
        <div>
          <h2>{labels.title}</h2>
          {fields.map(key=>
            <Section key={key} name={key} header={labels[key]} value={approach[key]}/>
          )}
        </div>
      ) : null;
  }
}

class ApproachTable extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant).approach;
    let approach=this.props.approach;
    let fields=["methods","resources","technology","rollOut","other"];
    var hasApproach=false;
    if (approach!==undefined && approach!==null) {
      fields.forEach(key=>{
        hasApproach=hasApproach || approach[key]!==undefined && approach[key]!==null
      })
    }
    return hasApproach ? (
        <div>
          <h2>{labels.title}</h2>
          <table className="briefTable" style={{fontSize:"inherit", borderCollapse: "collapse"}} cellPadding="0" cellSpacing="0">
            <tbody>
              {fields.map(key=>
                <TableRow key={key} label={labels[key]} content={approach[key]}/>
              )}
            </tbody>
          </table>
        </div>
      ) : null;
  }
}

class Organization extends React.Component {
  render() {
    let stakeholders=this.props.organization ? this.props.organization : [];
    let labels=translations.getTranslation(this.props.language,this.props.variant).organization;
    let projectRoles=
            [ {id:"Excecutive", name:labels.executive},
              {id:"Senior User", name:labels.seniorUser},
              {id:"Senior Supplier", name:labels.seniorSupplier},
              {id:"Business Assurance", name:labels.businessAssurance},
              {id:"User Assurance", name:labels.userAssurance},
              {id:"Supplier Assurance", name:labels.supplierAssurance},
              {id:"Project Manager", name:labels.projectManager},
              {id:"Project Support", name:labels.projectSupport},
              {id:"Change Authority",name:labels.changeAuthority},
              {id:"Team Manager", name:labels.teamManager},
              {id:"Team Member", name:labels.teamMember},
              {id:"Stakeholder", name:labels.stakeholder}
            ];
    let sortOrder=projectRoles.map(item=>
      item.id==='Excecutive'
      ? 'executive'
      : item.id.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
    )

    return stakeholders.length>0 ? (
      <div>
        <h2>{labels.title}</h2>
        <table style={{fontSize:"inherit", borderCollapse:"collapse", border: "solid 1px lightgrey", width:"100%"}}>
          <thead>
            <tr style={{backgroundColor: "#e9e7e6"}}>
              <th style={{border: "solid lightgrey 1px", padding:5}}>{labels.columns.name}</th>
              <th style={{border: "solid lightgrey 1px", padding:5}}>{labels.columns.role}</th>
              <th style={{border: "solid lightgrey 1px", padding:5}}>{labels.columns.description}</th>
            </tr>
          </thead>
          <tbody>
            {[].concat.apply([],stakeholders.map(stakeholder=>[Object.assign({},stakeholder,{
              role: stakeholder.role==='Excecutive' ? 'executive' : stakeholder.role.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase()) // to camelCase
            })]
              .concat(stakeholder.additionalRoles!==undefined
                ? stakeholder.additionalRoles
                    .map(item=>Object.assign({},stakeholder,item))
                : [])
            ))
            .map(item=>Object.assign({},item,{index:sortOrder.indexOf(item.role)}))
            .slice()
            .sort((a,b)=>sortOrder.indexOf(a.role)-sortOrder.indexOf(b.role))
            .map((person,index)=>(
              <tr key={index}>
                <td style={{border: "solid lightgrey 1px", padding:5, verticalAlign:"top"}}>{person.name}</td>
                <td style={{border: "solid lightgrey 1px", padding:5, verticalAlign:"top"}}>{labels[person.role]}</td>
                <td style={{border: "solid lightgrey 1px", padding:5, verticalAlign:"top"}}>{person.details}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : null;
  }
}

class ApproveForm extends React.Component {
  constructor(props) {
    super(props);
    this.state={approvedBy:""};
  }

  componentDidMount() {
    this.refs.element.scrollIntoView(true);
  }

  updateApprovedBy(event) {
    this.setState({approvedBy:event.target.value, message:undefined});
  }

  approve(event) {
    event.preventDefault();
    if (this.state.approvedBy.trim().length===0) {
      this.setState({message:"required field"});
    } else if (this.props.onApprove!==undefined) {
      this.props.onApprove(this.state.approvedBy);
    }
  }

  render() {
    let labels=translations.getTranslation(this.props).approval;
    return (
      <div ref="element" style={{marginTop:30, border: "solid 1px red", padding:30, marginBottom:20}}>
        <Field
          onChange={this.updateApprovedBy.bind(this)}
          title={labels.fields.approvedBy.title}
          value={this.state.approvedBy}
          description={labels.fields.approvedBy.description}
        />
        {this.state.message!==undefined ? (
          <div style={{marginTop:-15, paddingBottom:5, color:"red", fontSize: "80%"}}>{labels.thisFieldIsRequired}</div>
        ):null}
        <div style={{paddingTop:15, paddingBottom:20}}>
          <input onClick={this.props.onCancel} className="cancel" type="button" value={labels.cancel}/>
          <input onClick={this.approve.bind(this)} className="save" type="button" value={this.props.approveLabel}/>
        </div>
      </div>
    );
  }
}


export class BriefPidSlides  extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let pidSlides= this.props.pidSlides!==undefined ? this.props.pidSlides : [];
    let pidSlideTitles= this.props.pidSlideTitles!==undefined ? this.props.pidSlideTitles : [];
    let definitionLabels=translations.getTranslation(this.props.language,this.props.variant).definition;
    var date=this.props.date!==undefined ? new Date(Date.parse(this.props.date)).toISOString().slice(0,10) : new Date().toISOString().slice(0,10);
    let nameAndDate=(this.props.project!==undefined ? this.props.project.name+" - " : "")+date;
    let briefSlides=[ <FormattedSlide label={this.props.title}  content={nameAndDate}  slideType="title" />,
                      <FormattedSlide label={definitionLabels.background.title} content={this.props.doc.definition.background} slideType="preformatted">
                        <Background {...this.props} {...this.props.doc.definition.background} title="" />
                      </FormattedSlide>,
                      <FormattedSlide label={definitionLabels.objectives.title} content={this.props.doc.definition.objective} slideType="preformatted">
                        <Objectives {...this.props} {...this.props.doc.definition.objective} title="" />
                      </FormattedSlide>,
                      <FormattedSlide label={definitionLabels.scope.title} content={this.props.doc.definition.scope.items[0]} slideType="preformatted">
                        <Scope {...this.props} {...this.props.doc.definition} title="" />
                      </FormattedSlide>,
                      <FormattedSlide label={definitionLabels.constraints.title} content={this.props.doc.definition.constraints}/>,
                      <FormattedSlide label={definitionLabels.assumptions.title} content={this.props.doc.definition.assumptions}/>,
                      <FormattedSlide label={definitionLabels.stakeholders.title} content={this.props.doc.definition.stakeholders}/>,
                      <FormattedSlide label={definitionLabels.interfaces.title}  content={this.props.doc.definition.interfaces} />,
                      <BusinessCase {...this.props} {...this.props.doc.businessCase}/>,
                      <ProjectProductDescription {...this.props} items={this.props.doc.projectProductDescription}/>,
                      <Approach {...this.props} approach={this.props.doc.approach}/>,
                      <Organization {...this.props} organization={this.props.doc.organization}/> ];

      let briefSlideTitles=[labels.brief.frontPage,
                            definitionLabels.background.title,
                            definitionLabels.objectives.title,
                            definitionLabels.scope.title,
                            definitionLabels.constraints.title,
                            definitionLabels.assumptions.title,
                            definitionLabels.stakeholders.title,
                            definitionLabels.interfaces.title,
                            labels.businessCase.title,
                            labels.projectProductDescription.title,
                            labels.approach.title,
                            labels.organization.title];
    return (
      <div>
        <Slides slides={briefSlides.concat(pidSlides)} slideTitles={briefSlideTitles.concat(pidSlideTitles)}/>
      </div>
    );
  }
}

export class BriefContent extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);

    return this.props.showTable ? (
      <div>
        <DefinitionTable {...this.props} {...this.props.brief.definition}/>
        <BusinessCaseWithoutBenefitsTable {...this.props} {...this.props.brief.businessCase}/>
        {this.props.brief.businessCase!==undefined && this.props.brief.businessCase!==null
          && this.props.brief.businessCase.benefits!==undefined && this.props.brief.businessCase.benefits.length>0 ? (
          <div>
            <h3>{labels.businessCase.benefits.title}</h3>
            <BenefitsTable {...this.props} {...this.props.brief.businessCase}/>
          </div>
        ) : null}
        <ProjectProductDescriptionTable {...this.props} items={this.props.brief.projectProductDescription}/>
        <ApproachTable {...this.props} approach={this.props.brief.approach}/>
        <Organization {...this.props} organization={this.props.brief.organization}/>
      </div>
    ) : !this.props.presentationMode ? (
      <div>
        <Definition {...this.props} {...this.props.brief.definition}/>
        <BusinessCase {...this.props} {...this.props.brief.businessCase}/>
        <ProjectProductDescription {...this.props} items={this.props.brief.projectProductDescription}/>
        <Approach {...this.props} approach={this.props.brief.approach}/>
        <Organization {...this.props} organization={this.props.brief.organization}/>
      </div>
    ) : (
      <div>
        <BriefPidSlides {...this.props} doc={this.props.brief} />
      </div>
    );
  }
}

export class BriefDetails extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let date=this.props.brief!==undefined ? this.props.brief.date : undefined;
    let type=this.props.brief!==undefined ? this.props.brief.type : undefined;
    return (
      <ApprovableReport
        {...this.props}
        date={date}
        title={labels.brief.title}
        type={type}
        current={this.props.project.brief}
        selected={this.props.brief}
        report="Brief"
        approveLabel={labels.approval.approve}
        disabledActions={this.props.project.pid!==undefined && this.props.project.pid.history!==undefined}
        pidFollowUp={this.props.hasPreview && this.props.project.pid!==undefined && this.props.project.pid.history!==undefined}
      >
        <BriefContent {...this.props} title={labels.brief.title}/>
      </ApprovableReport>
    );
  }
}

export class ApprovableReport extends React.Component {
  constructor(props) {
    super(props);
    this.state={showApproval:this.props.showApproval===true};
  }

  showApprove() {
    this.setState({showApproval:true});
  }

  approveProjectBrief(approvedBy) {
    this.setState({showApproval:undefined})
    if (this.props.report!==undefined) {
      var command={type:"approve"+this.props.report+"Preview", approvedBy:approvedBy, project:{id: this.props.project.id}};
      if (this.props.selected.type==="draft") {
        command.type="approve"+this.props.report;
        command.version=this.props.selected.version;
      }
      sendCommand(command)
        .then(()=>{
          window.scrollTo(0, 0);
          window.location.reload();
        })
        .catch(()=>{
          alert("Failed to approve report");
        });
    } else {
      alert("No report type specified");
    }
  }

  cancelApproval(event) {
    event.preventDefault();
    this.setState({showApproval:undefined});
    window.scrollTo(0, 0);
  }

  render() {
    var date=this.props.date!==undefined ? new Date(Date.parse(this.props.date)).toISOString().slice(0,10) : new Date().toISOString().slice(0,10);
    let nameAndDate=(this.props.project!==undefined ? this.props.project.name+" - " : "")+date;
    let labels=translations.getTranslation(this.props);
    let approved=this.props.type!=="draft" && this.props.type!=="preview" && this.props.selected.approved!==undefined ? this.props.selected.approved : undefined;
    let reportStyle={textAlign:"left", maxWidth:1016};
    let style=Object.assign({},reportStyle,this.props.settings!==undefined ? this.props.settings.style : undefined);
    return (
      <div>
        {!this.props.presentationMode ? (
          <div style={{textAlign:"center"}}>
            {!this.props.fullPage ? (
              <div style={{textAlign:"left"}}>
                <BriefMenu {...this.props} onApprove={this.showApprove.bind(this)}/>
              </div>
            ) : null }
            <div style={{display:"inline-block", padding:5, paddingLeft:10, fontFamily: "Verdana, sans-serif", justifyContent:"center"}}>
              <div className="report" style={style}>
                <h1 style={{textAlign:"center"}}>
                  <div>{this.props.title}</div>
                  <div style={{fontSize:"80%"}}>{nameAndDate}</div>
                </h1>
                {this.props.type==="preview" ? (
                  <ReportMessage message={labels.brief.messagePreview}/>
                ) : null }
                {this.props.type==="draft" ? (
                  <ReportMessage message={labels.brief.messageDraft}/>
                ) : null }
                {this.props.children}
                {approved!==undefined ? (
                  <div style={{paddingTop:30, paddingBottom:30, textAlign:"center"}}>
                    {labels.approval.fields.approvedBy.title} {approved.user!==undefined ? approved.user.name : "(anonymous)"} {date}
                    {approved.description!==undefined && approved.description!==null && approved.description.trim().length>0 ? (
                      <span> ({approved.description})</span>
                    ) : null}
                  </div>
                ) : null}
                {this.state.showApproval ? (
                  <ApproveForm
                    {...this.props}
                    onCancel={this.cancelApproval.bind(this)}
                    onApprove={this.approveProjectBrief.bind(this)}
                  />
                ) : null}
              </div>
            </div>
        </div>
      ) : (
        <div style={{textAlign:"center", paddingRight:300}}>
          <div style={{display:"inline-block", padding:5, paddingLeft:10, fontFamily: "Verdana, sans-serif", justifyContent:"center"}}>
            <div className="report" style={style}>
              {this.props.children}
            </div>
          </div>
        </div>) }
    </div>
    );
  }
}

function ignoreUndefinedAndInvariants(key,value) {
  if (value===undefined || value===null) {
    return undefined
  } else {
    switch (key) {
      case "date":
      case "type":
      case "history":
      case "version":
        return undefined;
      default:
        return value;
    }
  }
}

class BriefVersion extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    let version=this.props.minorVersion!==undefined && this.props.minorVersion!==null && this.props.majorVersion!==undefined && this.props.majorVersion!==null ? (this.props.majorVersion+"."+this.props.minorVersion) : ("1."+this.props.version);
    return (
      <div style={{fontWeight:this.props.selected ? "bold": "normal"}}>
        <span>{version}</span>
        <span> </span>
        {this.props.type==="draft" ? labels.draft : ""}
        {this.props.date!==undefined ? (
          <span>
            <span> (</span>
            {new Date(Date.parse(this.props.date)).toISOString().slice(0,10)}
            <span>)</span>
          </span>
        ):null}
      </div>
    );
  }
}

class BriefMenu extends React.Component {
  createDraft(event) {
    event.preventDefault();
    if (this.props.report!==undefined) {
      let command="create"+this.props.report+"Draft";
      sendCommand({type:command, project:{id: this.props.project.id}})
        .then(()=>{
          window.location.reload();
        })
        .catch(error=>{
          console.log("Got error "+JSON.stringify(error),error);
          alert("Failed to create draft");
        });
    } else {
      alert("No report type specified");
    }
  }

  approvePreview(event) {
    event.preventDefault();
    if (this.props.onApprove!==undefined) {
      this.props.onApprove();
    }
  }

  url(parameters, withTable) {
    let version=this.props.selected!==undefined
      && (parameters==undefined || parameters.indexOf("version=")<0)
        ? this.props.selected.version
        : undefined;
    return (this.props.path!==undefined ? this.props.path : "")+"?"+(this.props.showTable && withTable!==false ? "showTable=true&" : "")+(version!==undefined ? "version="+version+"&" : "")+parameters;
  }

  render() {
    let labels=translations.getTranslation(this.props).menu;
    let selected=this.props.selected;
    let current=this.props.current;

    let type=selected!==undefined ? selected.type : undefined;
    let version=selected!==undefined ? selected.version : undefined;

    let hasCurrent=current!==undefined;
    let hasHistory=hasCurrent && current.history!==undefined && current.history.length>0;
    let currentType=hasCurrent ? current.type : undefined;
    let currentVersion=hasCurrent ? current.version : undefined;
    let history=hasCurrent ? current.history : [];

    return (
      <div style={{display:"inline-block", float: "right",marginRight: 30, width:250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft:10, paddingBottom: 150}}>
        {this.props.menuTopItems!==undefined ? this.props.menuTopItems : null}
        <div style={{paddingTop:15, display:this.props.hideReportDisplayMenu===true ? "none" : undefined}}>
          <b>{labels.reportActions}</b>
          <div style={{paddingLeft:10}}>
            <div><a href={this.url("fullPage=true")} target="_blank">{labels.viewFullScreen}</a></div>
            {this.props.definedTableView!==false && !this.props.showTable ?(
              <div><a href={this.url("showTable=true")}>{labels.tableView}</a></div>
            ) : null}
            {this.props.definedTableView!==false && this.props.showTable ?(
              <div><a href={this.url("",false)}>{labels.reportView}</a></div>
            ) : null}
            <div><a href={this.url("fullPage=true&pdf=true")} target="_blank">{labels.viewPDF}</a></div>
            <div><a href={this.url("fullPage=true&docx=true")} target="_blank">{labels.viewWord}</a></div>
            <div><a href={this.url("presentationMode=true")} target="_blank">{labels.viewSlideMode}</a></div>
            {this.props.disabledActions!==true ?
              <div>
                {type==="preview" && ((hasCurrent && currentType!=="draft") || !hasCurrent) ? (
                  <div onClick={this.createDraft.bind(this)} style={{cursor: "pointer", textDecoration: "underline"}}>{labels.createDraft}</div>
                ) : null}
                {type==="preview" && currentType==="draft" ? (
                  <div onClick={this.createDraft.bind(this)} style={{cursor: "pointer", textDecoration: "underline"}}>{labels.updateDraft}</div>
                ): null}
                {type==="preview" || type==="draft" ? (
                  <div onClick={this.approvePreview.bind(this)} style={{cursor: "pointer", textDecoration: "underline"}}>{labels.approve}</div>
                ) : null}
              </div>
            : null }
          </div>
        </div>

        {this.props.menuReportActions!==undefined ? this.props.menuReportActions : null}

        {hasCurrent!==undefined ? (
          <div style={{paddingTop:15}}>
            <b>{labels.documentArchive}</b>
            <div style={{paddingLeft:10}}>
              {this.props.hasPreview && (this.props.disabledActions!==true || this.props.showCurrent===true) ? (
                type==="preview" ? (
                  <div style={{fontWeight:type==="preview" ? "bold" : "normal"}}>{labels.current}</div>
                ) : (
                  <a href={this.url("version=")}><div style={{fontWeight:type==="preview" ? "bold" : "normal"}}>{labels.current}</div></a>
                )
              ) : null }
              {currentType==="draft" ? (
                type==="draft" ? (
                  <BriefVersion {...this.props} {...current} selected={currentType==="draft"}/>
                ) : (
                  <a href={this.url("version="+currentVersion+"-DRAFT")}><BriefVersion {...this.props} {...current} selected={type==="draft"}/></a>

                )
              ) : null }
              {hasHistory ?
                history.slice().reverse().map(item=>(
                  version===item.version ? (
                    <BriefVersion key={item.version} {...item} selected={version===item.version}/>
                  ) : (
                    <a key={item.version} href={this.url("version="+item.version)}><BriefVersion {...item} selected={version===item.version}/></a>
                  )
                ))
              : null }
            </div>
          </div>
        ) : null}
        {this.props.pidFollowUp && type==="draft"? (
          <div style={{paddingTop:15, paddingLeft: 10, fontSize:"80%", color:"#ff9999"}}>
            {labels.briefDetailsIsFollowedUpInPID}
          </div>
        ) : null}

        <div style={{display:"none", paddingTop:15}}>
          <b>Table of Content</b>
          <div style={{paddingLeft:10}}>
            <div style={{cursor: "pointer", textDecoration: "underline"}}>Definition</div>
            <div style={{cursor: "pointer", textDecoration: "underline"}}>Project Product Description</div>
          </div>
        </div>
      </div>
    );
  }
}

export class Brief extends React.Component {
  render() {
    var brief=getProjectBrief(this.props.project);
    let hasPreview=this.props.project.brief===undefined
      || this.props.project.brief!==undefined
        && JSON.stringify(brief,ignoreUndefinedAndInvariants)
          !==JSON.stringify(this.props.project.brief,ignoreUndefinedAndInvariants);
    if (hasPreview && (this.props.project.pid===undefined || (this.props.project.pid!==undefined && this.props.project.pid.history===undefined))) {
      brief=Object.assign({},brief,{type:"preview"});
    } else if (this.props.project.brief!==undefined) {
      brief=this.props.project.brief;
    }
    if (this.props.selected!==undefined) {
      if (this.props.selected.indexOf("-DRAFT")>0 && this.props.project.brief.type==="draft" && this.props.project.brief.version===parseInt(this.props.selected)) {
        brief=this.props.project.brief;
      } else if (this.props.project.brief!==undefined && this.props.project.brief.history!==undefined){
        let foundBrief=this.props.project.brief.history.filter(item=>item.version===parseInt(this.props.selected))[0];
        if (foundBrief!==undefined) {
          brief=foundBrief;
        }
      }
    }
    return (
      <BriefDetails {...this.props} brief={brief} hasPreview={hasPreview}/>
    );
  }
}

export default class BriefPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    let selected=this.props.selected;
    return this.props.fullPage ? (
      <html>
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></meta>
        </head>
        <body>
          <Brief {...this.props}/>
        </body>
      </html>
    ) :  (
      <Layout {...this.props} projectMenu={menu}>
        <Brief {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/brief/ProjectBrief.jsx